function removeInlineStyles(html) {
    return html
        .replace(/\s+style\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+class\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+data-[^=]*\s*=\s*["'][^"']*["']/gi, '');
}
function normalizeStructure(html) {
    return html
        .replace(/\n\s*\n\s*\n/g, '\n\n')
        .replace(/\s{2,}/g, ' ')
        .replace(/<p>\s*<\/p>/gi, '')
        .replace(/<div[^>]*>/gi, '')
        .replace(/<\/div>/gi, '')
        .replace(/<span[^>]*>/gi, '')
        .replace(/<\/span>/gi, '')
        .replace(/<ul[^>]*>/gi, '<ul>')
        .replace(/<ol[^>]*>/gi, '<ol>')
        .replace(/<li[^>]*>/gi, '<li>');
}
function removeUnnecessaryElements(html) {
    return html
        .replace(/<meta[^>]*>/gi, '')
        .replace(/<link[^>]*>/gi, '')
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<!--[\s\S]*?-->/gi, '')
        .replace(/<!DOCTYPE[^>]*>/gi, '')
        .replace(/<html[^>]*>/gi, '')
        .replace(/<\/html>/gi, '')
        .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
        .replace(/<body[^>]*>/gi, '')
        .replace(/<\/body>/gi, '')
        .replace(/\s+id\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+align\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+bgcolor\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+border\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+cellpadding\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+cellspacing\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+width\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\s+height\s*=\s*["'][^"']*["']/gi, '');
}
function applySemanticStructure(html) {
    let cleaned = html.replace(/<h([1-6])[^>]*>/gi, '<h$1>');
    cleaned = cleaned.replace(/<p[^>]*>/gi, '<p>');
    cleaned = cleaned.replace(/<a\s+[^>]+>/gi, match => {
        const hrefRegex = /href\s*=\s*["']([^"']*)["']/i;
        const targetRegex = /target\s*=\s*["']([^"']*)["']/i;
        const hrefMatch = hrefRegex.exec(match);
        const targetMatch = targetRegex.exec(match);
        let result = '<a';
        if (hrefMatch) {
            result += ` href="${hrefMatch[1]}"`;
        }
        if (targetMatch) {
            result += ` target="${targetMatch[1]}"`;
        }
        return result + '>';
    });
    return cleaned;
}
export function cleanDocumentHTML(html) {
    if (!html || typeof html !== 'string') {
        return '';
    }
    let cleanedHTML = html;
    cleanedHTML = removeUnnecessaryElements(cleanedHTML);
    cleanedHTML = removeInlineStyles(cleanedHTML);
    cleanedHTML = normalizeStructure(cleanedHTML);
    cleanedHTML = applySemanticStructure(cleanedHTML);
    cleanedHTML = cleanedHTML.trim();
    return cleanedHTML;
}
function isAllowedTag(tag) {
    const allowedTags = new Set([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p',
        'ul',
        'ol',
        'li',
        'strong',
        'b',
        'em',
        'i',
        'a',
        'br',
        'hr',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
        'blockquote',
    ]);
    const cleanTag = tag.replace(/^\//, '').toLowerCase();
    return allowedTags.has(cleanTag);
}
export function deepCleanDocumentHTML(html) {
    let cleaned = cleanDocumentHTML(html);
    cleaned = cleaned.replace(/<([^>\s]+)[^>]*>/gi, (match, tagName) => {
        return isAllowedTag(tagName) ? match : '';
    });
    return cleaned;
}
export function extractTextFromHTML(html) {
    return html
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
